import { createSelector } from '@ngrx/store';
import { InstrumentType } from '@zero/shared/util-models';
import { watchlistFeature } from './watchlist.reducers';

export const selectWatchlistHasNotes = createSelector(watchlistFeature.selectAll, (watchlist) => {
  return watchlist.some((item) => Boolean(item?.note));
});

export const selectIsOnWatchlist = (isin: string) =>
  createSelector(watchlistFeature.selectEntities, (watchlist) => {
    return Boolean(watchlist[isin]);
  });

export const selectWatchlistItem = (isin: string) =>
  createSelector(watchlistFeature.selectEntities, (watchlist) => {
    return watchlist[isin];
  });

export const selectWatchlistCryptoItems = createSelector(watchlistFeature.selectAll, (watchlist) => {
  return watchlist.filter((item) => item?.type === InstrumentType.Crypto);
});
export const selectWatchlistItems = createSelector(watchlistFeature.selectAll, (watchlist) => {
  return watchlist.filter((item) => item?.type !== InstrumentType.Crypto);
});

export const selectWatchlistItemsByIsin = (isins: string[]) =>
  createSelector(watchlistFeature.selectEntities, (watchlist) => {
    return isins.map((isin) => watchlist[isin]);
  });

export const selectWatchlistCategories = createSelector(selectWatchlistItems, (positions) => {
  return Object.keys(
    positions
      .filter((position) => !!position.type)
      .reduce((acc, position) => {
        acc[position.type] = [...(acc[position.type] || []), position];
        return acc;
      }, {}),
  );
});
